/* eslint-disable react/display-name */
import React from "react";
import { FormLabel, InputRightElement } from "@chakra-ui/core";
import { Icon } from "../icon";
import { pxToRem } from "../../../utils/dimensionConverter";

export const renderLabel = (label, requiredMark) => 
label && (
      <FormLabel
        fontSize={pxToRem(12)}
        width="100%"
        className={requiredMark && "field-required"}
      >
        {label}
      </FormLabel>
    );

export const renderTextCounter = (maxLength, textCounter)=>
  maxLength && (
    <span className="counter">
      {textCounter === 0 ? "" : textCounter}
    </span>
  )

export const renderIcon = (iconName)=> iconName && (
  <InputRightElement width="4.5rem">
    <Icon name={iconName} size={pxToRem(15)} />
  </InputRightElement>
)